import React, { useState, useEffect } from "react"
import axios from "axios"
import { BASE_URL } from "../../../Util/requests"
import Questionnaire from "../../../Components/Questionnaire"
import ClientContact from "../"
import image_add from "../../../Images/Buttons/add.png"
import image_delete from "../../../Images/Buttons/cancel.png"
import image_loading from "../../../Images/spinner.gif";
import image_select from "../../../Images/Buttons/select_circle.png"

const SearchClientContact = ({databaseType, databasePath, jClient, jsonCompany, jsonLogin, system, showMenu, width}) => {
  const [code, setCode] = useState(0)  
  const [update, setUpdate] = useState(0)
  const [showChange, setShowChange] = useState(false)

  const [jsonClientContact, setJsonClientContact] = useState("")

  const [result, setResult] = useState({})
  const [loading, setLoading] = useState("")
  const [warning, setWarning] = useState("")
  const [error, setError] = useState("")

  const [askQuestionnaire, setAskQuestionnaire] = useState("")
  const [showQuestionnaire, setShowQuestionnaire] = useState(false)

  useEffect(() => {
    let returnJson = []

    setLoading("Aguarde buscando as informações...")
    setWarning("")
    setError("")    

    const jClientContact = "{ \"CLIENT\": { \"ID\": " + jClient.ID + " } }"

    const formData = new FormData()
    formData.append("DATABASE_TYPE", databaseType)
    formData.append("DATABASE_PATH", databasePath)
    formData.append("JSON_NEW_1", jClientContact)
    formData.append("JSON_LOGIN", JSON.stringify(jsonLogin))
    formData.append("SYSTEM", system)

    axios.post(BASE_URL + "CLIENT_CONTACT/Search", formData)
    .then((response) => { returnJson = JSON.parse(response.data) })
    .catch((response) => { returnJson = JSON.parse("{ \"SUCCESS\": false, \"OBJECT\": null, \"AUDIT_CONFIGURATION\": null, \"WARNING\": null"+
      ", \"ERROR\": \"Não foi possível pesquisar os contatos do cliente. ("+ response +")\" }") })
    .finally(() => {
      if (returnJson.SUCCESS === false){
        setError(returnJson.ERROR)
        setLoading("")
        return
      }

      setResult(returnJson)
      setLoading("")
    })
  }, [databaseType, databasePath, jClient, jsonLogin, system, update])

  const add = () => {
    const jClientContact = "{ \"CLIENT\": { \"ID\": " + jClient.ID + " } }"

    setJsonClientContact(JSON.parse(jClientContact))
    setWarning("")
    setError("")
    setShowChange(true)
  }

  const back = () => {
    setWarning("")
    setError("")
    setShowChange(false)
  }

  const callDelete = (item) => {
    setCode(item.ID)
    setAskQuestionnaire("Deseja realmente excluir o Contato do Cliente (" + item.CONTACT + ") ?")
    setShowQuestionnaire(true)
  }

  const cancelDelete = () => {
    setShowQuestionnaire(false)
    setCode(0)
  }

  const confirmDelete = () => {
    let returnJson = []
    const jContact = "{ \"ID\": "+ code +" }"

    setLoading("Aguarde excluido o Contato...")
    setWarning("")
    setError("")

    const formData = new FormData()
    formData.append("DATABASE_TYPE", databaseType)
    formData.append("DATABASE_PATH", databasePath)
    formData.append("JSON_NEW_1", jContact)
    formData.append("JSON_COMPANY", JSON.stringify(jsonCompany))
    formData.append("JSON_LOGIN", JSON.stringify(jsonLogin))
    formData.append("SYSTEM", system)

    axios.post(BASE_URL + "CLIENT_CONTACT/Delete", formData)
    .then((response) => { returnJson = JSON.parse(response.data) })
    .catch((response) => { returnJson = JSON.parse("{ \"SUCCESS\": false, \"OBJECT\": null, \"AUDIT_CONFIGURATION\": null, \"WARNING\": null"+
    ", \"ERROR\": \"Não foi possível excluir o Contato do Cliente. ("+ response +")\" }") })
    .finally(() => {
      if (returnJson.SUCCESS === false){
        setError(returnJson.ERROR)
        setShowQuestionnaire(false)
        setCode(0)
        setLoading("")

        return
      }

      returnJson.WARNING && setWarning(returnJson.WARNING)

      setShowQuestionnaire(false)
      setCode(0)
      setLoading("")

      const count = update + 1
      setUpdate(count)
    })
  }

  const save = (clientContact) => {
    let returnJson = []
    const json = JSON.parse(clientContact)

    if (json.ID === undefined)
    {
      setLoading("Aguarde incluindo o Contato...")
      setWarning("")
      setError("")

      const formData = new FormData()
      formData.append("DATABASE_TYPE", databaseType)
      formData.append("DATABASE_PATH", databasePath)
      formData.append("JSON_NEW_1", clientContact)
      formData.append("JSON_LOGIN", JSON.stringify(jsonLogin))
      formData.append("JSON_COMPANY", JSON.stringify(jsonCompany))
      formData.append("SYSTEM", system)
      formData.append("GET_ID", true)

      axios.post(BASE_URL + "CLIENT_CONTACT/Insert", formData)
      .then((response) => { returnJson = JSON.parse(response.data) })
      .catch((response) => { returnJson = JSON.parse("{ \"SUCCESS\": false, \"OBJECT\": null, \"AUDIT_CONFIGURATION\": null, \"WARNING\": null"+
        ", \"ERROR\": \"Não foi possível incluir o Contato do Cliente. ("+ response +")\"}") })
      .finally(() => {
        if (returnJson.SUCCESS === false){
          setError(returnJson.ERROR)
          setLoading("")
          return
        }

        returnJson.WARNING ? setWarning("Inclusão efetuada com sucesso! ("+ returnJson.WARNING +")")
        : setWarning("Inclusão efetuada com sucesso!")

        setLoading("")
        setError("")
        setShowChange(false)

        const count = update + 1
        setUpdate(count)
      })
    }
    else
    {
      setLoading("Aguarde alterando o Contato...")
      setWarning("")
      setError("")

      const formData = new FormData()
      formData.append("DATABASE_TYPE", databaseType)
      formData.append("DATABASE_PATH", databasePath)
      formData.append("JSON_OLD", JSON.stringify(jsonClientContact))
      formData.append("JSON_NEW_1", clientContact)
      formData.append("JSON_COMPANY", JSON.stringify(jsonCompany))
      formData.append("JSON_LOGIN", JSON.stringify(jsonLogin))
      formData.append("SYSTEM", system)

      axios.put(BASE_URL + "CLIENT_CONTACT/Update", formData)
      .then((response) => { returnJson = JSON.parse(response.data) })
      .catch((response) => { returnJson = JSON.parse("{ \"SUCCESS\": false, \"OBJECT\": null, \"AUDIT_CONFIGURATION\": null, \"WARNING\": null"+
        ", \"ERROR\": \"Não foi possível alterar o Contato do Cliente. ("+ response +")\"}") })
      .finally(() => {
        if (returnJson.SUCCESS === false){
          setError(returnJson.ERROR)
          setLoading("")
          return
        }

        returnJson.WARNING ? setWarning("Alteração efetuada com sucesso! ("+ returnJson.WARNING +")")
        : setWarning("Alteração efetuada com sucesso!")

        setLoading("")
        setError("")
        setShowChange(false)

        const count = update + 1
        setUpdate(count)
      })
    }
  }

  const setSelected = (clientContact) => {
    setJsonClientContact(clientContact)
    setWarning("")
    setError("")
    setShowChange(true)
  }

  return(
    <div style={(width < 450) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginBottom: 10}
      : {display: "flex", flexDirection: "column", flexGrow: 0, paddingLeft: 10, paddingRight: 10, marginBottom: 10}}>

      { loading ?
          <div style={{display: "flex", flexDirection: "column", flexGrow: 0, justifyContent: "center", alignItems: "center", marginTop: 10,
            marginBottom: 10}}>
            <img style={{marginBottom: 10, height: 32, width: 32}} src={image_loading} alt="Carregando"/>
            <label style={{fontWeight: 600, color: "rgb(0, 177, 171)"}}>{loading}</label>
          </div>
        :
        <>
          { warning && 
            <div style={{display: "flex", flexGrow: 1, flexDirection: "row", justifyContent: "center", marginTop: 10, marginBottom: 10}}>
              <label style={{fontWeight: 600, color: "rgb(0, 177, 171)"}}>{warning}</label>
            </div> 
          }

          { error &&
            <div style={{display: "flex", flexGrow: 1, flexDirection: "row", justifyContent: "center", marginTop: 10, marginBottom: 10}}>
              <label style={{fontWeight: 600, color: "red"}}>{error}</label>
            </div>
          }

          { showChange ?
              <ClientContact
                databaseType={databaseType}
                databasePath={databasePath}
                jsonClientContact={jsonClientContact}
                jsonLogin={jsonLogin}
                system={system}
                save={save}
                back={back} 
                showMenu={showMenu}
                width={width} />
            :
              <>
                { showQuestionnaire ?
                    <div style={{marginTop: 10}}>
                      <Questionnaire
                        ask={askQuestionnaire}
                        setConfirm={() => confirmDelete()}
                        setCancel={() => cancelDelete()} />
                    </div>
                  :
                    <>
                      <div style={{display: "flex", flexDirection: "row", flexGrow: 0, flexWrap: "wrap", justifyContent: "center"}}>
                        <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, marginTop: 5,
                          marginLeft: 5, width: 147}} onClick={() => add()}>
                          <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5,
                            paddingRight: 10, paddingBottom: 5, paddingLeft: 10}}>
                            <img style={{height: 32, width: 32}} src={image_add} alt="Novo"/>
                          </div>
                          <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                            <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Novo</label>
                          </div>
                        </div>
                      </div>

                      <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <div style={{backgroundColor: "rgb(0, 177, 171)", marginTop: 8, height: 10, width: "98%"}} />
                      </div>

                      <div style={(width < 450) ? {paddingLeft: 5, paddingRight: 5}
                        : {paddingLeft: 10, paddingRight: 10}}>
                          
                        { result.OBJECT ?
                          <>
                            <div style={showMenu ?
                                (width < 680) ? {display: "flex", flexDirection: "column", flexGrow: 1, borderBottomColor: "black", borderBottomWidth: 2,
                                  borderBottomStyle: "solid", marginTop: 30, marginBottom: 4}
                                : (width < 690) ? {display: "flex", flexDirection: "row", flexGrow: 1, borderBottomColor: "black", borderBottomWidth: 2,
                                  borderBottomStyle: "solid", marginTop: 30, marginBottom: 4}
                                : (width < 970) ? {display: "flex", flexDirection: "column", flexGrow: 1, borderBottomColor: "black", borderBottomWidth: 2,
                                  borderBottomStyle: "solid", marginTop: 30, marginBottom: 4}
                                :
                                  {display: "flex", flexDirection: "row", flexGrow: 1, borderBottomColor: "black", borderBottomWidth: 2,
                                  borderBottomStyle: "solid", marginTop: 30, marginBottom: 4}
                              :
                                (width < 680) ? 
                                  {display: "flex", flexDirection: "column", flexGrow: 1, borderBottomColor: "black", borderBottomWidth: 2,
                                  borderBottomStyle: "solid", marginTop: 30, marginBottom: 4}
                                :
                                  {display: "flex", flexDirection: "row", flexGrow: 1, borderBottomColor: "black", borderBottomWidth: 2,
                                  borderBottomStyle: "solid", marginTop: 30, marginBottom: 4}}>

                              <div style={(showMenu) ?
                                  (width < 1700) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                  : {display: "flex", flexDirection: "row", flexGrow: 1}
                                :
                                  (width < 1420) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                  : {display: "flex", flexDirection: "row", flexGrow: 1}}>

                                <div style={(showMenu) ?
                                    (width < 1070) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                    : (width < 1700) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                    : {display: "flex", flexDirection: "row", flexGrow: 1, flexBasis: 1}
                                  :
                                    (width < 800) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                    : (width < 1420) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                    : {display: "flex", flexDirection: "row", flexGrow: 1, flexBasis: 1}}>
                                  <div style={{display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}}>
                                    <label style={{fontWeight: 600}}>Contato</label>
                                  </div>
                                  <div style={(showMenu) ?
                                      (width < 1070) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 18}
                                      : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 110, maxWidth: 110}
                                    :
                                      (width < 800) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 18}
                                      : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 110, maxWidth: 110}}>
                                    <label style={{fontWeight: 600}}>Nascim.</label>
                                  </div>
                                </div>

                                <div style={(showMenu) ?
                                    (width < 1070) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                    : (width < 1700) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                    : {display: "flex", flexDirection: "row", flexGrow: 1, flexBasis: 1}
                                  :
                                    (width < 800) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                    : (width < 1420) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                    : {display: "flex", flexDirection: "row", flexGrow: 1, flexBasis: 1}}>

                                  <div style={(showMenu) ?
                                      (width < 1070) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                      : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 110, maxWidth: 110}
                                    :
                                      (width < 800) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                      : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 110, maxWidth: 110}}>
                                    <label style={{fontWeight: 600}}>Telefone</label>
                                  </div>
                                  <div style={{display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}}>
                                    <label style={{fontWeight: 600}}>Email</label>
                                  </div>
                                </div>
                              </div>
                              <div style={showMenu ?
                                  (width < 680) ? {display: "flex", flexDirection: "row", flexGrow: 1, justifyContent: "center", marginTop: 10}
                                  : (width < 697) ? {display: "flex", flexDirection: "row", flexGrow: 0, alignItems: "center", marginLeft: 10, minWidth: 82,
                                    maxWidth: 82}
                                  : (width < 970) ? {display: "flex", flexDirection: "row", flexGrow: 1, justifyContent: "center", marginTop: 10}
                                  : {display: "flex", flexDirection: "row", flexGrow: 0, alignItems: "center", marginLeft: 10, minWidth: 82, maxWidth: 82}
                                :                                                              
                                  (width < 680) ? {display: "flex", flexDirection: "row", flexGrow: 1, justifyContent: "center", marginTop: 10}
                                  : {display: "flex", flexDirection: "row", flexGrow: 0, alignItems: "center", marginLeft: 10, minWidth: 82, maxWidth: 82}}/>
                            </div>

                            <div style={showMenu ? {display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minWidth: 32, maxWidth: 32}
                              : (width < 330) ? {display: "flex", flexGrow: 0, alignItems: "center", marginTop: 10, minWidth: 32, maxWidth: 32}
                                : {display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minWidth: 32, maxWidth: 32}} />

                            { result.OBJECT.map(item => (
                              <div key={item.ID} style={showMenu ?
                                  (width < 680) ? {display: "flex", flexDirection: "column", flexGrow: 1, backgroundColor: "rgb(241, 242, 242)",
                                    borderLeftStyle: "solid", borderLeftWidth: 5, paddingRight: 8, borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5,
                                    paddingTop: 8, paddingBottom: 8, marginTop: 4, minWidth: 180}
                                  : (width < 690) ? {display: "flex", flexDirection: "row", flexGrow: 1, alignItems: "center", 
                                    backgroundColor: "rgb(241, 242, 242)", borderLeftStyle: "solid", borderLeftWidth: 5, paddingRight: 8,
                                    borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5, paddingTop: 8, paddingBottom: 8, marginTop: 4, minWidth: 180}
                                  : (width < 970) ? {display: "flex", flexDirection: "column", flexGrow: 1, backgroundColor: "rgb(241, 242, 242)",
                                    borderLeftStyle: "solid", borderLeftWidth: 5, paddingRight: 8, borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5,
                                    paddingTop: 8, paddingBottom: 8, marginTop: 4, minWidth: 180}
                                  : 
                                    {display: "flex", flexDirection: "row", flexGrow: 1, alignItems: "center",
                                      backgroundColor: "rgb(241, 242, 242)", borderLeftStyle: "solid", borderLeftWidth: 5, paddingRight: 8,
                                      borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5, paddingTop: 8, paddingBottom: 8,
                                      marginTop: 4, minWidth: 180}
                                :
                                  (width < 680) ? {display: "flex", flexDirection: "column", flexGrow: 1, backgroundColor: "rgb(241, 242, 242)",
                                    borderLeftStyle: "solid", borderLeftWidth: 5, paddingRight: 8, borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5,
                                    paddingTop: 8, paddingBottom: 8, marginTop: 4, minWidth: 180}
                                  : 
                                    {display: "flex", flexDirection: "row", flexGrow: 1, alignItems: "center",
                                      backgroundColor: "rgb(241, 242, 242)", borderLeftStyle: "solid", borderLeftWidth: 5, paddingRight: 8,
                                      borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5, paddingTop: 8, paddingBottom: 8,
                                      marginTop: 4, minWidth: 180}}>
                          
                                <div style={(showMenu) ?
                                    (width < 1700) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                    : {display: "flex", flexDirection: "row", flexGrow: 1}
                                  :
                                    (width < 1420) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                    : {display: "flex", flexDirection: "row", flexGrow: 1}}>

                                  <div style={(showMenu) ?
                                      (width < 1070) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                      : (width < 1700) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                      : {display: "flex", flexDirection: "row", flexGrow: 1, flexBasis: 1}
                                    :
                                      (width < 800) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                      : (width < 1420) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                      : {display: "flex", flexDirection: "row", flexGrow: 1, flexBasis: 1}}>
                                    <div style={{display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}}>
                                      <label>{item.CONTACT}</label>
                                    </div>
                                    <div style={(showMenu) ?
                                        (width < 1070) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 18}
                                        : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 110, maxWidth: 110}
                                      :
                                        (width < 800) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 18}
                                        : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 110, maxWidth: 110}}>
                                      <label>{item.BIRTH_DATE !== "0001-01-01T00:00:00" && String(item.BIRTH_DATE).substr(8,2) + "/" + 
                                        String(item.BIRTH_DATE).substr(5,2) + "/" + String(item.BIRTH_DATE).substr(0,4)}
                                      </label>
                                    </div>
                                  </div>

                                  <div style={(showMenu) ?
                                      (width < 1070) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                      : (width < 1700) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                      : {display: "flex", flexDirection: "row", flexGrow: 1, flexBasis: 1}
                                    :
                                      (width < 800) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                      : (width < 1420) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                      : {display: "flex", flexDirection: "row", flexGrow: 1, flexBasis: 1}}>

                                    <div style={(showMenu) ?
                                        (width < 1070) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                        : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 110, maxWidth: 110}
                                      :
                                        (width < 800) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                        : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 110, maxWidth: 110}}>
                                      <label>{item.PHONE}</label>
                                    </div>
                                    <div style={{display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}}>
                                      <label>{item.EMAIL}</label>
                                    </div>
                                  </div>
                                </div>

                                <div style={showMenu ?
                                    (width < 680) ? {display: "flex", flexDirection: "row", flexGrow: 1, justifyContent: "center", marginTop: 10}
                                    : (width < 690) ? {display: "flex", flexDirection: "row", flexGrow: 0, alignItems: "center", marginLeft: 10}
                                    : (width < 970) ? {display: "flex", flexDirection: "row", flexGrow: 1, justifyContent: "center", marginTop: 10}
                                    : {display: "flex", flexDirection: "row", flexGrow: 0, alignItems: "center", marginLeft: 10}
                                  : 
                                    (width < 680) ? {display: "flex", flexDirection: "row", flexGrow: 1, justifyContent: "center", marginTop: 10}
                                    : {display: "flex", flexDirection: "row", flexGrow: 0, alignItems: "center", marginLeft: 10}}>
                                  <div style={{display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minWidth: 32, maxWidth: 32}}>
                                    <img
                                      style={{height: 32, width: 32}}
                                      src={image_select}
                                      name="searchClientContactSelected"
                                      alt="Selecionar"
                                      onClick={(() => setSelected(item))} />
                                  </div>

                                  <div style={{display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minWidth: 32, maxWidth: 32}}>
                                    <img
                                      style={{height: 28, width: 28}}
                                      src={image_delete}
                                      name="searchClientContactDeleted"
                                      alt="Deletar"
                                      onClick={() => callDelete(item)} />
                                  </div>
                                </div>
                              </div>
                            ))}
                          </>
                        :
                          <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", marginTop: 10,
                            marginBottom: 10}}>
                            <label style={{fontWeight: 600, color: "rgb(0, 177, 171)"}}>Nenhum registro encontrado.</label>
                          </div>
                      }
                      </div>
                    </>
                }
              </>
          }
        </>
      }
    </div>
  )
}

export default SearchClientContact